var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"headline",attrs:{"id":'statement_' + _vm.index}},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.iKey('act_section', 'act_section', 'statement_' + _vm.index, 'statement'))))])])}
var staticRenderFns = []

export { render, staticRenderFns }